import { T, useTranslate } from '@tolgee/react';
import { useRouter } from 'next/router';
import { useSession } from 'next-auth/react';
import { useEffect, useState } from 'react';
import Hotkeys from 'react-hot-keys';
import styled from 'styled-components';

import { useMetrics } from '../../../hooks/useMetrics';
import { zIndexes } from '../../../utils/zIndexes';
import { Button } from '../../_atoms/Button';
import ActivityOverlay from '../../_molecules/ActivityOverlay';
import { CenteredContainer } from '../../styled/CenteredContainer';
import Wordcloud from '../Wordcloud/Wordcloud';

const WordcloudView = ({
  gameId,
  roundId,
  isAuthenticated,
  uniqueId,
  refetchData,
}: {
  gameId: string;
  roundId: string;
  isAuthenticated: boolean;
  uniqueId?: string;
  refetchData?: boolean;
}) => {
  const router = useRouter();

  const { t } = useTranslate();
  const [showWordcloud, setShowWordcloud] = useState(false);
  useEffect(() => {
    setShowWordcloud(false);
    if (
      !isAuthenticated ||
      router.pathname === '/[tenantId]/games/[gameId]/live/results'
    ) {
      setShowWordcloud(true);
    } else {
      setShowWordcloud(false);
    }
  }, [roundId, isAuthenticated, router.pathname]);
  const metrics = useMetrics();
  const handleHPress = () => {
    setShowWordcloud(existing => !existing);
    metrics.logGameEvent('Wordcloud.Pressed.H');
  };
  const session = useSession();

  return (
    <>
      <Hotkeys keyName="h" onKeyUp={handleHPress} />
      <CenteredContainer
        style={{
          width: '100%',
          height: '100%',
          maxHeight: '100vh',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        {!showWordcloud && (
          <ActivityOverlay>
            <ActivateActivityContainer>
              <h1 style={{ textAlign: 'center', width: '100%' }}>
                {t('Show word cloud?', 'Show word cloud?')}
              </h1>
              <p>
                <span>
                  <T keyName="Click ok, or press" defaultValue="Click ok, or press" />
                </span>
                <span style={{ fontWeight: 800 }}>H</span>
                <span>
                  <T
                    keyName="to show the word cloud"
                    defaultValue="to show the word cloud"
                  />
                </span>
              </p>
              <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                <Button
                  onClick={() => {
                    metrics.logEvent('LiveGame.ShowActivity.ShowWordcloud');
                    setShowWordcloud(true);
                  }}
                >
                  <T keyName="Ok" defaultValue="Ok" />
                </Button>
              </div>
            </ActivateActivityContainer>
          </ActivityOverlay>
        )}

        <Wordcloud
          roundId={roundId}
          gameId={gameId}
          isAuthenticated={isAuthenticated}
          uniqueId={uniqueId}
          refetchData={refetchData}
        />
      </CenteredContainer>
    </>
  );
};

const ActivateActivityContainer = styled.div`
  background: #f9f3eb;
  border-radius: 20px;
  padding: 20px;
  z-index: ${zIndexes('SHOW_WORDCLOUD_OVERLAY')};
  margin: 1%;
  h1 {
    font-weight: bold;
  }

  p {
    font-weight: bold;
  }
  box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.2);
`;

export default WordcloudView;
